import type { ComposeQuotedBlock } from './types';
import { isTrivialHtml } from './classifyBodyKind';
import { plainTextToPreHtml } from './plainTextToHtml';
import { sanitizeEmailBodyForDisplay, sanitizeRichEmailHtml } from '../utils/sanitizeEmailBody';

/** True when quoted HTML contains inline images (cid or img tags). */
export function quotedHasInlineImages(html: string | null | undefined): boolean {
  if (!html?.trim()) return false;
  return /<img\b/i.test(html) || /cid\s*:/i.test(html);
}

/** Prefer HTML rendering when a non-trivial HTML body exists (matches message view). */
export function quotedShouldUseHtmlDisplay(quoted: ComposeQuotedBlock): boolean {
  const html = quoted.bodyHtml?.trim() ?? '';
  if (!html || isTrivialHtml(html)) return false;
  return true;
}

/** HTML for read-only quoted panel (rewrites cid: to API inline-image URLs). */
export function resolveQuotedBodyHtml(
  quoted: ComposeQuotedBlock,
  emailId: number | undefined,
  apiBaseUrl: string,
  partitionAt?: string | null,
): string {
  const html = quoted.bodyHtml?.trim() ?? '';
  if (html && !isTrivialHtml(html)) {
    if (emailId != null) {
      return sanitizeEmailBodyForDisplay(html, emailId, apiBaseUrl, partitionAt);
    }
    return sanitizeRichEmailHtml(html);
  }
  if (quoted.bodyText) {
    return plainTextToPreHtml(quoted.bodyText);
  }
  return '';
}

/** HTML for outbound send (keeps cid: refs so backend can embed inline parts). */
export function resolveQuotedBodyHtmlForSend(quoted: ComposeQuotedBlock): string {
  const html = quoted.bodyHtml?.trim() ?? '';
  if (html && !isTrivialHtml(html)) {
    return html;
  }
  if (quoted.bodyText) {
    return plainTextToPreHtml(quoted.bodyText);
  }
  return '';
}
